// src/pages/BundeslandMecklenburgVorpommern.jsx
import React from "react";
import BundeslandPage from "./BundeslandPage";
import { mecklenburgVorpommern } from "../components/states/mecklenburg-vorpommern";

export default function BundeslandMecklenburgVorpommern() {
  return <BundeslandPage data={mecklenburgVorpommern} />;
}

